'use strict';

class Slider {

    constructor() {

        this.imageSlider();
        this.expertiseSlider();
        this.contentImageSlider();

    }

    imageSlider() {

        const imageSliders = document.querySelectorAll('.ce-image-slider');

        if (imageSliders.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/package/js/swiper.min.js');

            for (const slider of imageSliders) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    effect: 'cards'
                });

            }

        }

    }

    expertiseSlider() {

        const expertiseSliders = document.querySelectorAll('.expertise__slider-images');

        if (expertiseSliders.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/package/js/swiper.min.js');

            for (const slider of expertiseSliders) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    watchOverflow: true,
                    loop: true,
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true
                    }
                });

            }

        }

    }

    contentImageSlider() {

        const contentImageSliders = document.querySelectorAll('.ce-content-image-slider__images');

        if (contentImageSliders.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/package/js/swiper.min.js');

            for (const slider of contentImageSliders) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    watchOverflow: true,
                    loop: true,
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true
                    }
                });

            }

        }

    }

}

module.exports = Slider;
